import React from 'react';
import Img from '../../Img';

const TableColumnImg = (props) => {
  const { url, width = '80px', height = '80px' } = props;
  return url ? <Img style={{ width, height }} src={url} /> : <>-</>;
};

export default TableColumnImg;
